import {create} from 'zustand';
import {FormAccordionStore} from './types';

export const useFormAccordionStore = create<FormAccordionStore>(set => ({
	type: undefined,
	setType: type => set({type}),
	reset: () => set({type: undefined}),
}));
